import { useTranslation } from 'react-i18next'
import { ArrowUpRight } from 'lucide-react'

interface RemakeApplyTabBarProps {
  tab: 'content' | 'media'
  onTabChange: (next: 'content' | 'media') => void
  onOpenProduct: () => void
}

const TAB_BASE = 'px-4 py-2.5 text-sm transition-colors'
const TAB_ACTIVE =
  'font-semibold text-neutral-900 dark:text-neutral-100 border-b-2 border-orange-500'
const TAB_INACTIVE =
  'text-neutral-500 hover:text-neutral-900 dark:hover:text-neutral-300'

export function RemakeApplyTabBar({
  tab,
  onTabChange,
  onOpenProduct,
}: RemakeApplyTabBarProps) {
  const { t } = useTranslation()
  return (
    <div className="flex items-center justify-between border-b border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 px-6">
      <div className="flex">
        <button
          type="button"
          onClick={() => onTabChange('content')}
          aria-current={tab === 'content' ? 'page' : undefined}
          className={`${TAB_BASE} ${tab === 'content' ? TAB_ACTIVE : TAB_INACTIVE}`}
        >
          {t('remakeApply.tabs.content')}
        </button>
        <button
          type="button"
          onClick={() => onTabChange('media')}
          aria-current={tab === 'media' ? 'page' : undefined}
          className={`${TAB_BASE} ${tab === 'media' ? TAB_ACTIVE : TAB_INACTIVE}`}
        >
          {t('remakeApply.tabs.media')}
        </button>
      </div>
      <button
        type="button"
        id="remake-apply-open-product"
        onClick={onOpenProduct}
        aria-label={t('remakeApply.openProduct')}
        className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-neutral-600 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-lg"
      >
        <span>{t('remakeApply.openProduct')}</span>
        <ArrowUpRight className="w-4 h-4" />
      </button>
    </div>
  )
}
